/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { candidateFileDestroy } from '../../axios/candidateFileDestroy'
import type {
	CandidateFileDestroyError,
	CandidateFileDestroyPathParams,
	CandidateFileDestroyResponse,
} from '../../types/CandidateFileDestroy'

export const candidateFileDestroyMutationKey = () => [{ url: '/candidates/:candidateId/files/:fileId' }] as const

export type CandidateFileDestroyMutationKey = ReturnType<typeof candidateFileDestroyMutationKey>

export type CandidateFileDestroyVariables = {
	candidateId: CandidateFileDestroyPathParams['candidateId']
	fileId: CandidateFileDestroyPathParams['fileId']
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/CandidateFileController.php CandidateFileController::destroy */
export function useCandidateFileDestroy<TContext = unknown>(
	options?: UseMutationOptions<
		CandidateFileDestroyResponse,
		AxiosError<CandidateFileDestroyError>,
		CandidateFileDestroyVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: candidateFileDestroyMutationKey(),
		mutationFn: ({ candidateId, fileId }: CandidateFileDestroyVariables) =>
			candidateFileDestroy(candidateId, fileId, config).then(res => res.data),
		...options,
	})
}
